import React, { useEffect, useState } from 'react';
import HeaderComponent from '../../component/base/header-component/HeaderComponent';
import FooterComponent from '../../component/base/footer-component/FooterComponent';
import OnboardButton from '../../component/base/onboard-button-component/OnboardButton';
import OnboardTable from '../../component/base/onboard-table-component/OnboardTable';
import parse from 'html-react-parser';
import CacheManager from '../../util/CacheManager';
import Const from '../../constant/Const';
import { getWifiPackagesByLogout } from '../../example/getWifiPackagesByLogout';
import { getPackageName } from '../../util/LanguageContentManager';
import { setSimulationNumber } from '../../util/SimulationManager';

const InternetPackagesPage = (props) => {
    const { t, i18n, navigate, flight, setLoading, handleInformation } = props.props;
    const simulationNumber = setSimulationNumber();

    const [empty, setEmpty] = useState(false);
    const tableHeader = [t('quota'), t('buy_price')];
    const [body, setBody] = useState([]);
    const [sortList, setSortList] = useState([]);
    const cacheManager = new CacheManager(Const.INTERNET_PACKAGES);

    useEffect(() => {
        handleInformation('internet_packages');
        simulationNumber(5, 1);

        if (useCache()) return;
        setLoading(true);

        let result = getWifiPackagesByLogout;
        setLoading(false);
        if (result.data != null) {
            setEmpty(false);
            const sortList = result.data;
            setSortList(sortList);
            cacheManager.setCache(sortList);
            setupWifiPackages(sortList);
        } else
            setEmpty(true);

    }, []);

    useEffect(() => {
        setupWifiPackages(sortList);
    }, [i18n.language]);

    const useCache = () => {
        let cacheData = cacheManager.getCache();
        if (cacheData !== null) {
            setEmpty(false);
            setSortList(cacheData);
            setupWifiPackages(cacheData);
            return true;
        }
        return false;
    };

    const setupWifiPackages = (sortList) => {
        if (sortList.length > 0) {
            let list = [];
            sortList.forEach(value => {
                let price = (flight.domestic ? value.priceTL + ' TL' : value.priceUSD + ' USD');
                list.push({ text: getPackageName(i18n, value), result: price });
            });
            setBody(list);
        }
    };

    return (
        <div className="full-height-screen">
            <HeaderComponent title={t('internet_package.title')} content={t('internet_package.content')} showBack />

            <div className="content-root top m-b-34">

                {body.length !== 0 && <OnboardTable header={tableHeader} body={body} />}

                {body.length === 0 &&
                    <p className="text-center m-t-150 m-b-170">{parse(empty ? t('purchase_package.error.service') : t('please_wait'))}</p>}
            </div>

            <div className="content-root">
                <OnboardButton label={t('login.sign_up_miles_smiles')}
                               onClick={() => navigate('/miles-and-smiles-register', { state: 'login' })} />
            </div>

            <FooterComponent />

        </div>
    );
};

export default InternetPackagesPage;
